import { graphql } from '@generated/gql';

export const FETCH_FLAG_GLOSSARY = graphql(`
  query fetchFlagGlossary($organizationId: ObjectID!) {
    fetchFlagGlossary(organizationId: $organizationId) {
      flagType
      label
      category
      isActive
      isAmountThresholdable
      axis
      inherited {
        priority
        thresholdCents
        percentThreshold
      }
      actual {
        priority
        thresholdCents
        percentThreshold
      }
    }
  }
`);
